import { useTranslation } from '../presentation/common/useTranslation.js';
import { Compass, Home, RotateCcw, ArrowLeft, Lock } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';

import '../styles/world.css';
import { getPresentation } from '../presentation/runtime';

export default function ErrorPage({ status, onRetry }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const kind = status === 404 ? 'notFound' : status === 403 ? 'forbidden' : status === 401 ? 'session' : 'unavailable';
  
  return (
    <section className="world-error-page" role="alert">
      <div className="world-error-glow" aria-hidden="true" />
      <div className="world-error-orbit" aria-hidden="true">
        {kind === 'unavailable' || kind === 'session' ? (
          <img src={getPresentation().errorImage} alt="Rastender Wanderer am Lagerfeuer" className="world-error-pixel-art" />
        ) : kind === 'forbidden' ? (
          <Lock className="world-error-icon" />
        ) : (
          <Compass className="world-error-icon" />
        )}
        <span className="world-error-sparkle">✧</span>
      </div>
      <span className="world-eyebrow">✦ GOODVALE · {status || t('errorPage.notice')} ✦</span>
      <h1>{t(`errorPage.${kind}.title`)}</h1>
      <p>{t(`errorPage.${kind}.description`)}</p>
      <div className="world-divider">◇</div>
      <div className="world-error-actions">
        {onRetry && (
          <button type="button" className="world-button world-button-primary" onClick={onRetry}>
            <RotateCcw size={18} />
            {t('errorPage.retry')}
          </button>
        )}
        <Link className="world-button" to={status === 401 ? '/login' : '/dashboard'}>
          <Home size={18} />
          {t(status === 401 ? 'errorPage.login' : 'errorPage.home')}
        </Link>
        <button type="button" className="world-more" onClick={() => navigate(-1)}>
          <ArrowLeft size={16} />
          {t('errorPage.back')}
        </button>
      </div>
    </section>
  );
}

